import { render } from "./ListInternalTransferOfProductsView.vue?vue&type=template&id=9f444846"
import script from "./ListInternalTransferOfProductsView.vue?vue&type=script&lang=js"
export * from "./ListInternalTransferOfProductsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__